import { render, staticRenderFns } from "./settlement-list-component.vue?vue&type=template&id=35f864b0&scoped=true&"
import script from "./settlement-list-component.vue?vue&type=script&lang=js&"
export * from "./settlement-list-component.vue?vue&type=script&lang=js&"
import style0 from "./settlement-list-component.vue?vue&type=style&index=0&id=35f864b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f864b0",
  null
  
)

export default component.exports